/* BrainyTots — skill world (sections/bt-skill-world.liquid). Ported from mockups/skill.html.
 *   - paper diorama for the skill + the hanging tag on a pendulum (tap it to give it a push)
 *   - the ladder: one hero toy per focus area (BT.subsOf), ordered by the age it starts;
 *     falls back to age steps when the skill has no focus matches. On phones it is a swipeable
 *     staircase and the paper tot climbs to the step in the middle (with a haptic tick).
 *   - filters (age band × focus × "fits my child now") that show/hide the server-rendered cards
 *   - kits for this skill (catalogue kinds kit|box) and mini scenes for the other skills
 */
(function () {
  'use strict';
  if (window.__btSkill) return;
  window.__btSkill = true;

  const small = () => (window.M && M.small ? M.small() : matchMedia('(max-width: 760px)').matches);
  const haptic = (p) => { if (window.M && M.haptic) M.haptic(p); };
  const fill = (tpl, map) => String(tpl || '').replace(/\{(\w+)\}/g, (m, k) => (Object.prototype.hasOwnProperty.call(map, k) ? map[k] : m));
  const startAge = (p) => (p.a ? p.a[0] : 999);
  /** in stock first, then the youngest start, then parents' picks */
  const byFit = (x, y) => (y.ok - x.ok) || startAge(x) - startAge(y) || (y.pick - x.pick);
  const ageOf = (el) => {
    const v = String(el.dataset.age || '').split(',').map(Number);
    return v.length === 2 && v.every((n) => isFinite(n)) ? v : null;
  };
  const overlaps = (a, lo, hi) => !!a && a[0] <= hi && a[1] >= lo; // same rule as BT.query({age})
  /** used for age steps when the page has no filter bar (twin of the chips in the section) */
  const BANDS = [[1, 0, 6, '0–6 months'], [2, 6, 12, '6–12 months'], [3, 12, 24, '1–2 years'], [4, 24, 36, '2–3 years'], [5, 36, 72, '3–6 years']]
    .map(([i, lo, hi, long]) => ({ i, lo, hi, long, label: long }));

  /* ---------- hero: diorama + swinging tag ---------- */
  function hero(root, sid) {
    const host = root.querySelector('[data-sk-hero]');
    if (!host || !window.Paper || !window.Scenes) return;
    const Paper = window.Paper;
    let dio;
    try {
      dio = new Paper.Diorama(host, {
        seed: 300 + sid.length * 17, depths: [2, 4, 6], skyClass: 'sk-sky-' + sid, overDepth: 4,
        scene: Scenes.skill(sid), hangers: Scenes.skillHangers(sid),
      });
    } catch (e) { console.warn('[bt-skill] diorama', e); return; }
    const tag = host.querySelector('[data-tag]');
    if (!tag) return;
    let ang = -2, vel = 0;
    tag.style.transform = 'rotate(-1.4deg)';
    if (Paper.reduce) return;
    dio.onTick((dt, t) => {
      const rest = -1.4 + Math.sin(t * 0.6) * 0.5;
      vel += (-(ang - rest) * 26 - vel * 2.6) * dt;
      ang += vel * dt;
      tag.style.transform = `rotate(${ang.toFixed(2)}deg)`;
    });
    // a tap on the tag (not its button) sets it swinging
    tag.addEventListener('pointerdown', (e) => { if (!e.target.closest('a, button')) { vel += (e.clientX > tag.getBoundingClientRect().left + tag.offsetWidth / 2 ? -1 : 1) * 38; haptic(6); } });
  }

  /* ---------- folder tabs: keep the current skill in view on phones ---------- */
  function tabs(root) {
    const wrap = root.querySelector('[data-tabs]');
    const cur = wrap && wrap.querySelector('.is-current');
    if (!cur || wrap.scrollWidth <= wrap.clientWidth + 2) return;
    wrap.scrollLeft = Math.max(0, cur.offsetLeft - (wrap.clientWidth - cur.offsetWidth) / 2);
  }

  /* ---------- filters over the server-rendered grid ---------- */
  function filters(root) {
    const grid = root.querySelector('[data-grid]');
    const fAge = root.querySelector('[data-fage]');
    if (!grid || !fAge) return null;
    const BT = window.BT;
    const fSub = root.querySelector('[data-fsub]');
    const fitWrap = root.querySelector('[data-fit-wrap]');
    const fitInput = root.querySelector('[data-fit-input]');
    const fitText = root.querySelector('[data-fit-text]');
    const countEl = root.querySelector('[data-count]');
    const emptyEl = root.querySelector('[data-empty]');
    const paged = countEl && +countEl.dataset.pages > 1;
    const cards = Array.from(grid.querySelectorAll('.pc[data-h]')).map((el) => ({ el, h: el.dataset.h, a: ageOf(el) }));
    const bandBtns = Array.from(fAge.querySelectorAll('[data-band]'));
    const bands = bandBtns.map((b) => ({
      i: +b.dataset.band, lo: +b.dataset.min || 0, hi: b.dataset.max != null ? +b.dataset.max : 999,
      label: b.textContent.trim(), long: b.dataset.long || b.textContent.trim(), btn: b,
    }));
    const band = (i) => bands.find((b) => b.i === i);
    const state = { band: 0, sub: null, fit: false };
    let subsByH = {};

    // hide age bands with nothing in them on this page ("All" stays); no ages at all → no age row
    bands.forEach((b) => { if (b.i) b.btn.hidden = !cards.some((c) => overlaps(c.a, b.lo, b.hi)); });
    fAge.hidden = !bands.some((b) => b.i && !b.btn.hidden);
    const bar = root.querySelector('[data-filters]');
    const updateBar = () => { if (bar) bar.hidden = fAge.hidden && (!fSub || fSub.hidden) && (!fitWrap || fitWrap.hidden); };

    function passes(c) {
      const b = state.band ? band(state.band) : null;
      if (b && !overlaps(c.a, b.lo, b.hi)) return false; // no age → only in "All"
      if (state.sub && (subsByH[c.h] || []).indexOf(state.sub) < 0) return false;
      if (state.fit) {
        const f = BT.fit({ a: c.a });
        if (!f || (f.state !== 'now' && f.state !== 'soon')) return false;
      }
      return true;
    }
    function sync() {
      bands.forEach((b) => b.btn.setAttribute('aria-pressed', String(b.i === state.band)));
      if (fSub) fSub.querySelectorAll('[data-sub]').forEach((c) => c.setAttribute('aria-pressed', String((c.dataset.sub || null) === state.sub)));
      if (fitInput) fitInput.checked = state.fit;
    }
    function apply() {
      let n = 0;
      cards.forEach((c) => { const ok = passes(c); c.el.hidden = !ok; if (ok) n++; });
      const b = state.band ? band(state.band) : null;
      if (countEl) {
        countEl.textContent = `${n} ${n === 1 ? 'item' : 'items'}${state.sub ? ' · ' + state.sub : ''}${b ? ' · ' + b.label : ''}${paged ? ' on this page' : ''}`;
      }
      if (emptyEl) emptyEl.hidden = n > 0 || !cards.length;
      sync();
    }
    function set(next) {
      Object.assign(state, next);
      if (state.band && !band(state.band)) state.band = 0;
      apply();
    }

    fAge.addEventListener('click', (e) => {
      const b = e.target.closest('[data-band]');
      if (!b) return;
      haptic(5);
      set({ band: +b.dataset.band });
    });
    if (fSub) fSub.addEventListener('click', (e) => {
      const b = e.target.closest('[data-sub]');
      if (!b) return;
      haptic(5);
      set({ sub: b.dataset.sub || null });
    });
    if (fitInput) fitInput.addEventListener('change', () => set({ fit: fitInput.checked }));
    const clear = root.querySelector('[data-clear]');
    if (clear) clear.addEventListener('click', () => set({ band: 0, sub: null, fit: false }));

    /* "Only what fits <name>" appears once a child profile exists (and follows changes to it) */
    function childToggle() {
      if (!fitWrap) return;
      const m = BT.childMonths();
      if (m == null) {
        fitWrap.hidden = true;
        if (state.fit) set({ fit: false });
        return;
      }
      const c = BT.getChild() || {};
      if (fitText) {
        fitText.textContent = fill(root.dataset.fitLabel || 'Only what fits {name} ({age}) — now or soon', {
          name: c.name || 'my little one', age: BT.fmtAge(Math.max(0, m)),
        });
      }
      fitWrap.hidden = false;
      if (state.fit) apply();
    }
    childToggle();
    updateBar();
    document.addEventListener('bt:child', updateBar);
    document.addEventListener('bt:child', childToggle);

    /** Focus chips, once the catalogue is in: a sub counts when any card on this page matches it. */
    function setFocus(S, extraSubs) {
      if (!fSub || !S || !S.focus || !S.focus.length) return;
      subsByH = {};
      cards.forEach((c) => { const p = BT.product(c.h); subsByH[c.h] = p ? BT.subsOf(p, S) : []; });
      const present = S.subs.filter((sub) => cards.some((c) => subsByH[c.h].indexOf(sub) > -1) || (extraSubs || []).indexOf(sub) > -1);
      if (!present.length) return;
      fSub.querySelectorAll('[data-sub]').forEach((b) => b.remove());
      fSub.insertAdjacentHTML('beforeend', [''].concat(present)
        .map((x) => `<button type="button" class="chip" data-sub="${BT.esc(x)}" aria-pressed="false">${x ? BT.esc(x) : 'All'}</button>`).join(''));
      fSub.hidden = false;
      updateBar();
      sync();
    }

    apply();
    return { set, setFocus, bands, state };
  }

  /* ---------- the ladder ---------- */
  function buildSteps(S, items, bands) {
    let steps = [];
    if (S && S.focus && S.focus.length) {
      const used = {};
      steps = S.subs.map((sub) => {
        const list = items.filter((p) => BT.subsOf(p, S).indexOf(sub) > -1).sort(byFit);
        if (!list.length) return null;
        const heroP = list.find((p) => !used[p.h]) || list[0];
        used[heroP.h] = 1;
        const ages = list.filter((p) => p.a).map((p) => p.a[0]);
        return { label: sub, sub, hero: heroP, n: list.length, from: ages.length ? Math.min.apply(null, ages) : null };
      }).filter(Boolean);
      steps.sort((x, y) => (x.from == null ? 999 : x.from) - (y.from == null ? 999 : y.from));
    }
    if (steps.length < 2) {
      // no (or one) focus match → climb by age instead: one step per age band, by the age a toy starts
      const byAge = (bands || []).filter((b) => b.i).map((b) => {
        const list = items.filter((p) => p.a && p.a[0] >= b.lo && p.a[0] < b.hi).sort(byFit);
        return list.length ? { label: b.long, band: b.i, hero: list[0], n: list.length, from: Math.min.apply(null, list.map((p) => p.a[0])) } : null;
      }).filter(Boolean);
      if (byAge.length > steps.length) steps = byAge;
    }
    return steps;
  }

  function ladder(root, S, items, F) {
    const sec = root.querySelector('[data-ladder-sec]');
    const L = root.querySelector('[data-ladder]');
    if (!sec || !L) return [];
    const BT = window.BT;
    const steps = buildSteps(S, items, F ? F.bands : BANDS);
    if (!steps.length) { sec.hidden = true; return steps; }
    const color = (S && S.color) || root.dataset.color || 'sky';
    const n = steps.length;
    const rise = n > 1 ? Math.min(40, 200 / (n - 1)) : 0;
    const lede = root.querySelector('[data-ladder-lede]');
    if (lede) {
      const first = steps[0].from;
      lede.textContent = fill(root.dataset.lede, { steps: n, from: first ? BT.fmtAge(first) : 'birth' });
    }
    L.style.setProperty('--n', n);
    L.innerHTML = steps.map((st, i) => {
      const p = st.hero;
      const more = st.n > 1
        ? `<button type="button" class="riser-more" ${st.sub ? `data-sub="${BT.esc(st.sub)}"` : `data-band="${st.band}"`} aria-label="See all ${st.n} for ${BT.esc(st.label)}">+${st.n - 1} more</button>`
        : '';
      const from = st.from == null ? '' : st.from ? 'from ~' + BT.fmtAge(st.from) : 'from birth';
      return `<li class="step">
        <span class="step-n" aria-hidden="true">${i + 1}</span>
        <div class="step-card sheet"><div class="step-paper stock cut">
          <a class="step-photo" href="${BT.esc(p.u)}" tabindex="-1" aria-hidden="true">${p.img[0] ? `<img loading="lazy" src="${BT.esc(BT.img(p.img[0], 360))}" alt="" width="360" height="360">` : '<span class="step-noimg"></span>'}</a>
          <h3 class="step-name"><a href="${BT.esc(p.u)}">${BT.esc(p.n)}</a></h3>
          <div class="step-meta"><span>${BT.rupees(p.p)}</span><small>${BT.ageRange(p.a)}</small></div>
        </div></div>
        <div class="riser stock cut" style="--h:${Math.round(92 + i * rise)}px;--stock:var(--${color}-${i % 2 ? 'l' : 'xl'})">
          <b><span class="sr-only">Step ${i + 1}: </span>${BT.esc(st.label)}</b>${from ? `<small>${from}</small>` : ''}
          ${more}
        </div>
      </li>`;
    }).join('');

    /* phones: swipe the staircase and the tot climbs to the step in the middle */
    const stepEls = Array.from(L.querySelectorAll('.step'));
    const tot = document.createElement('li');
    tot.className = 'ladder-tot';
    tot.setAttribute('aria-hidden', 'true');
    tot.innerHTML = BT.I && BT.I.tot ? BT.I.tot : '';
    L.appendChild(tot);
    const hint = root.querySelector('[data-swipe-hint]');
    if (hint) hint.innerHTML = stepEls.map(() => '<i></i>').join('') + `<span>${BT.esc(root.dataset.swipe || 'Swipe to climb')}</span>`;
    const dots = hint ? Array.from(hint.querySelectorAll('i')) : [];
    let cur = -1;
    function climb(i) {
      const st = stepEls[i];
      if (!st) return;
      const card = st.querySelector('.step-card');
      tot.style.transform = `translate(${Math.round(st.offsetLeft + st.offsetWidth / 2 - 20)}px, ${Math.round(st.offsetTop + card.offsetTop - 64)}px)`;
      stepEls.forEach((s, k) => s.classList.toggle('is-on', k === i));
      dots.forEach((d, k) => d.classList.toggle('is-on', k === i));
    }
    const nearest = () => {
      const c = L.scrollLeft + L.clientWidth / 2;
      let best = 0, bd = 1e9;
      stepEls.forEach((s, k) => { const d = Math.abs(s.offsetLeft + s.offsetWidth / 2 - c); if (d < bd) { bd = d; best = k; } });
      return best;
    };
    let raf = 0;
    L.addEventListener('scroll', () => {
      if (raf || !small()) return;
      raf = requestAnimationFrame(() => {
        raf = 0;
        const b = nearest();
        if (b !== cur) { cur = b; climb(b); haptic(6); }
      });
    }, { passive: true });
    const settle = () => { if (small()) climb(Math.max(0, cur)); };
    setTimeout(() => { if (small()) { cur = nearest(); climb(cur); } }, 300);
    addEventListener('resize', settle, { passive: true });
    L.addEventListener('load', settle, true); // images change the step heights
    // on phones a tap on a side step brings it to the middle instead of opening it
    L.addEventListener('click', (e) => {
      if (!small() || e.target.closest('[data-sub], [data-band]')) return;
      const st = e.target.closest('.step');
      const i = stepEls.indexOf(st);
      if (st && i !== cur) {
        e.preventDefault();
        L.scrollTo({ left: st.offsetLeft + st.offsetWidth / 2 - L.clientWidth / 2, behavior: 'smooth' });
      }
    });

    /* "+N more" → filter the grid to that step and jump there */
    L.addEventListener('click', (e) => {
      const m = e.target.closest('.riser-more');
      if (!m || !F) return;
      if (m.dataset.sub != null) F.set({ sub: m.dataset.sub, band: 0 });
      else F.set({ band: +m.dataset.band, sub: null });
      const shop = root.querySelector('[data-shop-sec]');
      if (shop) shop.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
    return steps;
  }

  /* ---------- kits for this skill ---------- */
  function kits(root, pool) {
    const sec = root.querySelector('[data-kits-sec]');
    const shelf = root.querySelector('[data-kits]');
    if (!sec || !shelf) return;
    const list = pool.filter((p) => p.k === 'kit' || p.k === 'box').sort(byFit).slice(0, 12);
    if (!list.length) return;
    shelf.innerHTML = list.map((p) => BT.ui.card(p)).join('');
    sec.hidden = false;
  }

  /* ---------- other skills: little paper worlds ---------- */
  function others(root) {
    if (!window.Paper || !window.Scenes) return;
    root.querySelectorAll('[data-mini-scene]').forEach((el) => {
      if (el.firstChild) return;
      try { el.innerHTML = Paper.miniScene(Scenes.skill(el.dataset.miniScene), 320, 130, +el.dataset.seed || 41); } catch (e) {}
    });
  }

  /* ---------- about this skill: collapsible on phones ---------- */
  function about(root) {
    const box = root.querySelector('[data-about]');
    const body = box && box.querySelector('[data-about-body]');
    const btn = box && box.querySelector('[data-about-more]');
    if (!body || !btn) return;
    box.classList.add('is-clamp');
    const measure = () => {
      if (box.classList.contains('is-open')) return;
      btn.hidden = !small() || body.scrollHeight <= body.clientHeight + 8;
    };
    measure();
    addEventListener('resize', measure, { passive: true });
    btn.addEventListener('click', () => {
      const open = box.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', String(open));
      btn.querySelector('[data-more-open]').hidden = open;
      btn.querySelector('[data-more-close]').hidden = !open;
      if (!open) box.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    });
  }

  /* ---------- one section ---------- */
  function init(root) {
    if (!root || root.dataset.skInit) return;
    root.dataset.skInit = '1';
    const BT = window.BT;
    const sid = root.dataset.sid || 'thinking';
    const handle = root.dataset.collection || '';
    hero(root, sid);
    tabs(root);
    const F = filters(root);
    others(root);
    about(root);
    BT.load().then(() => {
      const S = +root.dataset.slot ? (BT.SKILLS.find((s) => s.collection && s.collection === handle) || BT.skill(sid)) : null;
      // this skill's products: the collection's own + anything else tagged with the skill
      const pool = BT.products().filter((p) => (p.c || []).indexOf(handle) > -1 || (S && p.s.indexOf(S.id) > -1));
      const items = pool.filter((p) => p.k === 'toy' || p.k === 'book' || p.k === 'digital');
      const steps = ladder(root, S, items, F);
      if (F) F.setFocus(S, steps.map((st) => st.sub).filter(Boolean));
      kits(root, pool);
      BT.ui.refresh(root);
    }).catch((e) => {
      console.warn('[bt-skill]', e);
      const sec = root.querySelector('[data-ladder-sec]');
      if (sec) sec.hidden = true;
    });
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-section-root][data-bt-skill]').forEach(init);
  }
  function start() {
    if (!window.BT || !BT.onReady) return;
    BT.onReady(() => initAll(document));
  }
  start();
  document.addEventListener('shopify:section:load', (e) => {
    if (!window.BT || !BT.onReady) return;
    BT.onReady(() => { initAll(e.target); if (BT.ui) BT.ui.refresh(e.target); });
  });
})();
